
export class PasswordSanitizer
{
    public static Sanitize(password: string): string
    {
        return password?.trim()?.toLowerCase()?.replace(/[_\s\t\n]+/g, '_') ?? "";
    }
}
